export type ControlMode = "fps" | "flight";

export type StickVector = {
  x: number;
  y: number;
};

export const clampStickVector = ({ x, y }: StickVector): StickVector => {
  const magnitude = Math.sqrt(x * x + y * y);
  if (magnitude <= 1) {
    return { x, y };
  }
  const scale = 1 / magnitude;
  return {
    x: x * scale,
    y: y * scale,
  };
};
